import { r as registerInstance, h, H as Host, g as getElement } from './index-61528ac5.js';
import { v as version } from './package-27c9b485.js';

const postTabPanelCss = ":host{display:none}";
const PostTabPanelStyle0 = postTabPanelCss;

const PostTabPanel = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.panelId = undefined;
        this.name = undefined;
    }
    componentWillLoad() {
        // get the id set on the host element or use a random id by default
        this.panelId = `panel-${this.host.id || crypto.randomUUID()}`;
    }
    render() {
        return (h(Host, { key: '2d01a8e7f06e45b4750e63584a3c52232dee4dd5', "data-version": version, id: this.panelId, role: "tabpanel" }, h("slot", { key: 'b51e2f112791ac22df43ebb537208c65aebe3d03' })));
    }
    get host() { return getElement(this); }
};
PostTabPanel.style = PostTabPanelStyle0;

export { PostTabPanel as P };
